// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

// import {Api} from "#/api";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class CWLandingpageMesseTeaserModul extends ModuleBase {
  private currentDate: Date | undefined;
  private targetDate: Date | undefined;

  public countdownTimer: number | undefined;
  public countdownIsVisible = true;

  public countdown = {
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
    offset: 0,
  };

  public timeConfig = {
    second: 1000,
    minute: 1000 * 60,
    hour: 1000 * 60 * 60,
    day: 1000 * 60 * 60 * 24,
  };

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public created() {
    this.initializeCountdown();
  }

  /*
    private animateCount(target, val) {
        let steps = 1500 / val,
            current = 0;

        let valPerStep = 1500 / steps;

        var inter = window.setInterval(() => {
            current += valPerStep;
            this.countdown[target] = this.zeroPad(Math.ceil(current));
            if (current >= val) {
                window.clearInterval(inter);
            }
        }, steps);
    }
    */

  public initializeCountdown() {
    this.$refs.countdownCnt;

    let cTargetDate = this.getTargetDate(),
      cCurrentDate = this.getCurrentDate();

    if (cCurrentDate === undefined || cTargetDate === undefined) return false;

    let dateDistance = cTargetDate.getTime() - cCurrentDate.getTime();
    this.countdown.offset = Date.now();

    let distance = dateDistance - (Date.now() - this.countdown.offset);
    let t = this.calculateTime(distance);

    /*
        this.animateCount('days', days);
        this.animateCount('hours', hours);
        this.animateCount('minutes', minutes);
        this.animateCount('seconds', seconds)
        */

    this.countdown["days"] = this.zeroPad(t["days"]);
    this.countdown["hours"] = this.zeroPad(t["hours"]);
    this.countdown["minutes"] = this.zeroPad(t["minutes"]);
    this.countdown["seconds"] = this.zeroPad(t["seconds"]);

    setTimeout(() => {
      this.countdownTimer = window.setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }, 5000);
  }

  private calculateTime(distance) {
    let d = {
      days: Math.floor(distance / this.timeConfig.day),
      hours: Math.floor(
        (distance % this.timeConfig.day) / this.timeConfig.hour
      ),
      minutes: Math.floor(
        (distance % this.timeConfig.hour) / this.timeConfig.minute
      ),
      seconds: Math.floor(
        (distance % this.timeConfig.minute) / this.timeConfig.second
      ),
    };
    return d;
  }

  private zeroPad(number) {
    return ("0" + number).slice(-2);
  }

  public updateCountdown() {
    let cTargetDate = this.getTargetDate(),
      cCurrentDate = this.getCurrentDate();

    if (cCurrentDate === undefined || cTargetDate === undefined) return false;

    let dateDistance = cTargetDate.getTime() - cCurrentDate.getTime();

    let distance = dateDistance - (Date.now() - this.countdown.offset);

    if (distance < 0) {
      window.clearInterval(this.countdownTimer);
      this.countdownIsVisible = false;
      return;
    }

    let t = this.calculateTime(distance);

    let activeCircles = Math.floor((60 - t["seconds"]) / 3);
    let circles = <HTMLElement[]>this.$refs.countdownCircle;

    for (let i = 0; i < circles.length; i++) {
      let circle = circles[i];

      if (i <= activeCircles) {
        circle.style.fill = "#00adef";
      } else {
        circle.style.fill = "none";
      }
    }

    this.countdown["days"] = this.zeroPad(t["days"]);
    this.countdown["hours"] = this.zeroPad(t["hours"]);
    this.countdown["minutes"] = this.zeroPad(t["minutes"]);
    this.countdown["seconds"] = this.zeroPad(t["seconds"]);
  }

  public buttonTheme(type) {
    switch (type) {
      case "wb-e-btn-1":
        return "primary";
      case "wb-e-btn-2":
        return "default";
      case "wb-e-btn-3":
        return "inverted";
      case "button_outline":
        return "outline-secondary";
      default:
        return "default";
    }
  }

  public checkTargetDateLargerCurrentDate() {
    let cDate = this.getCurrentDate(),
      tDate = this.getTargetDate();

    return tDate && tDate > cDate;
  }

  public getTargetDate() {
    if (this.targetDate !== undefined) return this.targetDate;

    let d = this.instance["counter"]["date"].split(".");
    let target = new Date(
      `${d[2]}-${d[1]}-${d[0]} ${this.instance["counter"]["time"]}`
    );
    // let target = new Date(this.instance['counter']['date'] + ' ' + this.instance['counter']['time']);

    if (target instanceof Date) {
      this.targetDate = target;
      return this.targetDate;
    }

    return undefined;
  }

  public getCurrentDate() {
    if (this.currentDate !== undefined) return this.currentDate;

    let current = new Date();
    this.currentDate = current;
    return this.currentDate;
  }

  private parseDateToStr(target) {
    if (isNaN(target.getFullYear())) return "null";
    return `${target.getFullYear()}-${
      target.getMonth() + 1
    }-${target.getDate()}T${target.getHours()}:${target.getMinutes()}:${target.getSeconds()}`;
  }
}
